<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6 v-if="user.role.roleName == 'WAREHOUSE_MANAGER'">
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            Register
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.createdDate"
                  label="Created Date"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="queryParams.createdDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="barcode"
                label="Barcode"
                type="text"
                v-model="queryParams.barcode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="warehouseList"
                item-text="name"
                item-value="id"
                label="Choose Warehouse"
                v-model="queryParams.warehouseId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                item-text="name"
                item-value="id"
                label="Choose Category"
                v-model="queryParams.categoryId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                item-text="name"
                item-value="id"
                label="Choose Brand"
                v-model="queryParams.brandId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="stockTakeList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.brandName }}</td>
              <td>{{ props.item.categoryName }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.barcode }}</td>
              <td>{{ props.item.factor }}/{{ props.item.unitName }}</td>
              <td>{{ props.item.openingBalance }}</td>
              <td>{{ props.item.stockInQty }} / {{ props.item.stockOutQty }}</td>
              <td>{{ props.item.stockTransferInQty }} / {{ props.item.stockTransferOutQty }}</td>
              <td>{{ props.item.stockAdjustmentLossQty }} / {{ props.item.stockAdjustmentDamageQty }} / {{ props.item.stockAdjustmentRefoundedQty }}</td>
              <td>{{ props.item.closingBalance }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { stockTakeService } from "../../services/stock-take-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
export default {
  name: "StockTakeList",

  components: {},
  data: () => ({
    user: {},
    createdDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Stock Take",
        disabled: true
      }
    ],
    headers: [
      {
        text: "Created Date",
        align: "left",
        value: "createdDate",
        sortable: false
      },
      { text: "Created By", value: "createdBy", sortable: false },
      { text: "Warehouse", value: "warehouseId" },
      { text: "Brand", value: "brand", sortable: false },
      { text: "Category", value: "category", sortable: false },
      { text: "Product", value: "product", sortable: false },
      { text: "Barcode", value: "barcode", sortable: false },
      { text: "Unit", value: "unit", sortable: false },
      { text: "Open BL", value: "openBl", sortable: false },
      { text: "Stock In / Out", value: "stockInOut", sortable: false },
      {
        text: "Transfer In / Out",
        value: "stockTransferInOut",
        sortable: false
      },
      {
        text: "Adjustment Loss / Damage / Re-founded",
        value: "adjustmentLossDamageRefounded"
      },
      { text: "Close BL", value: "closeBl" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "warehouseId",
      totalItems: 0
    },
    stockTakeList: [],
    brandList: [],
    categoryList: [],
    warehouseList: [],
    totalRows: 0,
    queryParams: {
      createdDate: "",
      warehouseId: "",
      barcode: "",
      brandId: "",
      categoryId: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockTakeList();
      },
      deep: true
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    //for deep linking
    if (this.$route.query.createdDate) {
      this.queryParams.createdDate = this.$route.query.createdDate;
    } else {
      this.queryParams.createdDate = this.createdDate;
    }
    if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
      this.queryParams.warehouseId = this.user.warehouseId;
    } else if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.barcode) {
      this.queryParams.barcode = this.$route.query.barcode;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }

    if (this.user.role.roleName == "ADMIN" || this.user.role.roleName == "BRANCH_ADMIN") {
      this.getAllWarehouse();
    }
    this.getAllBrand();
    this.getAllCategory();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-takes",
        query: this.queryParams
      });
      this.getStockTakeList();
    },
    getStockTakeList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTakeService
        .getAllStockTake(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockTakeList = res.data.stockTakeList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getAllBrand() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getAllCategory() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getAllWarehouse() {
      warehouseService
        .getAllWarehouse()
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    onRegister() {
      this.$router.push("/stock-take-register");
    }
  }
};
</script>